<template>
  <div>
    <validation-observer ref="replaceDiscussion">
      <div class="py-1 px-4 rounded">
        <div class="row mt-4">
          <div class="col-9 d-flex">
            <i class="fas fa-repeat text-orange mr-2 mt-1"></i>
            <p class="callout-sub-section-title">
              Reemplazar Documento de Discusión
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ValidationProvider
              v-slot="{ errors, validate }"
              mode="lazy"
              rules="required"
              :custom-messages="{
                required: 'Este campo es requerido.'
              }"
            >
              <CustomTextArea
                class="wide-text-area"
                label="Razón de Reemplazo:"
                v-model="comment"
                regular-label
                :rows="3"
                :maxlength="500"
                show-char-count
                :count-classes="['d-block text-right', 'small-counter']"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="validate"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Archivo"
              rules="required"
            >
              <CustomFileInput
                class="wide-text-area2"
                ref="attachedDocument"
                label="Documento:"
                v-model="fileDiscussion"
                required
                :accept="'pdf'"
                display-style="normal"
                label-position="left"
                :error="errors[0]"
                custom-error-msg="Favor
              anejar documento."
                :on-download="downloadFile"
              />
            </ValidationProvider>
          </div>
          <div
            class="button-container d-flex justify-content-end align-items-center"
          >
            <action-button
              type="button"
              text="Cancelar"
              i="fa fa-times-circle"
              variant="outline-danger"
              class="ml-4 px-4 actionButton"
              @click="close()"
            />

            <action-button
              type="button"
              text="Guardar"
              i="fas fa-save"
              variant="success"
              class="ml-2 px-4 actionButton"
              @click="save()"
            />
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import Callout from "custom-callout";
import CustomTextArea from "CustomTextArea";
import CustomFileInput from "CustomFileInput";
import transitionStudentService from "@/services/pei/transitionStudent.js";
import mixAlert from "@/mixin/alert.mixin";
export default {
  name: "replaceDiscussion",
  components: {
    ActionButton,
    Callout,
    CustomTextArea,
    CustomFileInput
  },
  mixins: [mixAlert],
  mounted() {},
  props: {
    transitionStudentSAEE12Id: {
      type: Number,
      default: null,
      require: true
    }
  },
  data: () => ({
    comment: null,
    fileDiscussion: null,
    newDocumentId: null
  }),
  methods: {
    async save() {
      let validationResult = await this.$refs.replaceDiscussion.validate();
      if (validationResult) {
        try {
          const formData = new FormData();
          formData.append("FileDiscussion", this.fileDiscussion);
          formData.append("Comment", this.comment);
          formData.append(
            "TransitionStudentSAEE12Id",
            this.transitionStudentSAEE12Id
          );
          this.newDocumentId = (
            await transitionStudentService.replaceDiscussionDocument(formData)
          ).data;
          this.ShowToast(
            "",
            "El documento ha sido reemplazado de manera exitosa.",
            "success"
          );
          this.close();
        } catch (err) {
          this.ShowToast("", "Error al crear la solicitud.", "error");
        }
      }
    },
    async close() {
      this.fileDiscussion = null;
      this.comment = null;
      this.$emit("onClose", this.newDocumentId);
    },
    downloadFile() {}
  }
};
</script>

<style lang="scss" scoped>
.wide-text-area {
  width: 100%;
}
.wide-text-area2 {
  width: 130%;
  margin-bottom: 5%;
}
.button-container {
  margin-left: 165ch;
  align-items: start;
  margin-top: -80px;
}
label {
  font-weight: normal !important;
}
</style>
